export default __webpack_public_path__ + "static/media/lastTen.8e93d22e.png";